import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './plugins/axios';
import VueI18n from 'vue-i18n'
import VueLazyload from 'vue-lazyload'
import Loading from '@components/LoadingComponent'
import './assets/css/element-variables.scss'
Vue.component("Loading", Loading )
import { Icon, NavBar,Popup,Sidebar, SidebarItem} from 'vant';
Vue.component(NavBar.name, NavBar);
Vue.component(Icon.name, Icon);
Vue.component(Popup.name, Popup);
Vue.component(Sidebar.name, Sidebar);
Vue.component(SidebarItem.name, SidebarItem);
import {Input,Button,Checkbox,Form,FormItem,Message,Pagination,Option,Select,Image} from 'element-ui';
Vue.component(Input.name, Input);
Vue.component(Button.name, Button);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);
Vue.component(Pagination.name, Pagination);
Vue.component(Option.name, Option);
Vue.component(Select.name, Select);
Vue.component(Image.name, Image);
Vue.prototype.$message = Message;
Vue.use(VueI18n)
Vue.use(VueLazyload)

const i18n = new VueI18n({
  locale: 'zh-CN',    // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': require('./assets/js/zh'),   // 中文语言包
    'en-US': require('./assets/js/en')    // 英文语言包
  }
})


Vue.prototype.axios = axios;
Vue.prototype.url = require('../config/global').url

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
